/**
 * A row's facts in a table's phone layout, as one line under its title: the
 * parts that are there, in order, joined by commas ("46 oproepen, 1 fout").
 * A part that is missing (null, undefined, false or blank) is left out, so
 * the line never shows an empty slot or a stray comma.
 */
export function factLine(parts: readonly (string | null | undefined | false)[]): string {
  return parts
    .filter((part): part is string => typeof part === "string" && part.trim() !== "")
    .join(", ");
}
